"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolverBottomLeft(_a) {
    var trigger = _a.trigger, content = _a.content, viewport = _a.viewport;
    var left = trigger.leftBottomAnchor.x;
    var top = trigger.leftBottomAnchor.y - content.height;
    if (left + content.width <= viewport.width && top > 0) {
        return {
            left: left,
            top: top,
        };
    }
    return false;
}
exports.default = resolverBottomLeft;
//# sourceMappingURL=resolverBottomLeft.js.map